export default __webpack_public_path__ + "static/media/who-let-the-dogs-short2.edb37408.mp3";